<template>
    <v-card>
        <my-son name="aaa" @help="listen"></my-son>
        <my-son name="bbb"></my-son>
        <my-son name="ccc"></my-son>
        <my-doughter name="eee"></my-doughter>
        <v-card-text>
            <v-alert v-model="call" type="success">
                this is a success alert
            </v-alert>
        </v-card-text>
    </v-card>
   
</template>
<script>

// mother 뷰에서 
// 카멜 케이스로 MySon ,  MyDoughter 을 만들고
// 이를 components에 선언한다.
// 선언 된 MySon,MyDoughter 는 케밥케이스로 vue에서 사용할 수 있다.
// MySon === my-son  ,   MyDoughter === my-doughter
import MySon from "../../components/mySon"
import MyDoughter from "@/components/myDoughter"

export default {
    components : {
        MySon, MyDoughter
    },
    data () {
        return{
            call: false
        }
    },
    methods : {
        listen () {
            this.call = true
            //this.call = !this.call
        }
    }
}
</script>